module.exports = __webpack_public_path__ + "7f6cd7f7a87eda4cfdc98845e43d4d3e.MP3";